import { useNavigate } from "react-router-dom";
import { useToast } from "@/components/ui/use-toast";
import PromotionalCard from "./PromotionalCard";

export const DashboardPromotionalCards = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mt-6 sm:mt-8 animate-fade-up">
      <PromotionalCard
        title="Life Insurance Quote"
        description="Get a personalized life insurance quote in minutes. Protect your loved ones with the right coverage."
        icon="heart"
        actionLabel="Get Quote"
        onClick={() => navigate("/quote")}
      />
      <PromotionalCard
        title="Referral Program"
        description="Refer a friend and get a $20 gift card when they get a quote. It's our way of saying thank you!"
        icon="gift"
        actionLabel="Refer a Friend"
        onClick={() => {
          toast({
            title: "Coming Soon",
            description: "Our referral program will be available soon!",
          });
        }}
      />
      <PromotionalCard
        title="Leave a Review"
        description="Love our service? Share your experience on Google and help others find the right insurance coverage."
        icon="star"
        actionLabel="Write a Review"
        onClick={() => {
          window.open('https://www.google.com/search?q=your+insurance+agency', '_blank');
        }}
      />
    </div>
  );
};